module.exports = __webpack_public_path__ + "img/恒秀妍.1ee0400.png";